module.exports = __webpack_public_path__ + "static/img/valparaiso-crew-ulysses.8b044a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crew/valparaiso-crew-ulysses.jpg
// module id = 233
// module chunks = 0